import { getAPI } from "../api";

// Tiempo máximo de una lectura de listados o fichas: pasado este plazo se muestra el error con «Reintentar».
export const TIEMPO_CARGA = 30000;
export const cargar = url => getAPI(url, { timeout: TIEMPO_CARGA });

/**
 * Reducers de una lectura (pending/fulfilled/rejected) que nunca dejan `loading` bloqueado:
 * un error o un tiempo agotado guarda el mensaje en `error` y la página ofrece reintentar.
 * Solo cuenta la última petición del slice: una respuesta tardía de otra página no pisa la actual.
 * `destino` es el campo que recibe los datos o una función (state, payload).
 * Uso: `extraReducers: builder => { seguimiento(builder, fetchX, 'campo'); }`.
 */
export function seguimiento(builder, thunk, destino) {
  const guardar = typeof destino === 'function' ? destino : (state, payload) => { state[destino] = payload; };
  return builder
    .addCase(thunk.pending, (state, { meta }) => { state.loading = true; state.error = null; state.peticion = meta.requestId; })
    .addCase(thunk.fulfilled, (state, { payload, meta }) => {
      if (meta.requestId !== state.peticion) return;
      state.loading = false; guardar(state, payload);
    })
    .addCase(thunk.rejected, (state, { error, meta }) => {
      if (meta.requestId !== state.peticion) return;
      state.loading = false; state.error = error?.message || 'No se pudo completar la operación';
    });
}
